(() => {
  if (window.raawArchiveSizes) return;
  window.raawArchiveSizes = true;
  let activeGrid, controller, selected = new Set(new URL(location.href).searchParams.getAll('raaw_size'));
  let timer;
  const allowedSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  selected = new Set([...selected].filter(size => allowedSizes.includes(size)));
  const sizesOf = card => {
    try { return JSON.parse(card.dataset.archiveStockSizes || '[]').map(size => size === '2XL' ? 'XXL' : size); } catch { return []; }
  };
  const rank = value => {
    const index = ['XXS','XS','S','M','L','XL','XXL','XXXL','2XL','3XL'].indexOf(value.toUpperCase());
    return index < 0 ? 100 : index;
  };
  async function mount() {
    const nav = document.querySelector('.raaw-archive-filters');
    const grid = document.querySelector('[data-archive-pages]');
    if (!nav) return;
    if (!grid) {
      const status = nav.querySelector('[data-archive-size-status]');
      status.textContent = nav.dataset.sizeEmpty;
      return;
    }
    if (grid === activeGrid) return;
    activeGrid = grid;
    if (controller) controller.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const options = nav.querySelector('[data-archive-size-options]');
    const status = nav.querySelector('[data-archive-size-status]');
    options.replaceChildren();
    let initialCards = [...grid.querySelectorAll(':scope > [data-archive-product]')];
    let cards = [...initialCards];
    const section = grid.closest('.shopify-section');
    const products = grid.closest('.collection-grid__products');
    const count = section.querySelector('.collection-grid__results-count');
    const originalCount = count?.innerHTML;
    const siblings = [...products.children].filter(el => el !== grid);
    const recommendations = section.querySelector('.raaw-clothing-recommendations');
    let empty = document.createElement('p');
    empty.className = 'raaw-archive-size-hidden';
    empty.setAttribute('role', 'status');
    empty.textContent = nav.dataset.sizeEmpty;
    products.append(empty);
    try {
      const pages = Number(grid.dataset.archivePages);
      const current = Number(grid.dataset.archivePage);
      const byPage = new Map([[current, initialCards]]);
      for (let page = 1; page <= pages; page++) {
        if (page === current) continue;
        const url = new URL(location.href);
        url.searchParams.set('section_id', grid.dataset.archiveSection);
        url.searchParams.set('page', page);
        url.searchParams.delete('raaw_size');
        const response = await fetch(url, {signal});
        if (!response.ok) throw new Error('Archive page failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fetched = doc.querySelector('[data-archive-pages]');
        if (!fetched) throw new Error('Archive grid missing');
        byPage.set(page, [...fetched.querySelectorAll(':scope > [data-archive-product]')]);
      }
      if (signal.aborted || !grid.isConnected) return;
      cards = [...byPage.entries()].sort((a,b) => a[0]-b[0]).flatMap(entry => entry[1]);
      const stockedSizes = new Set(cards.flatMap(sizesOf));
      const choices = allowedSizes.filter(size => stockedSizes.has(size));
      const makeButton = (value, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.dataset.sizeValue = value;
        button.addEventListener('click', () => {
          if (selected.size === 0) initialCards = [...grid.querySelectorAll(':scope > [data-archive-product]')];
          if (!value) selected.clear();
          else if (selected.has(value)) selected.delete(value);
          else selected.add(value);
          const url = new URL(location.href);
          url.searchParams.delete('raaw_size');
          [...selected].forEach(size => url.searchParams.append('raaw_size', size));
          try { window.history?.replaceState(null, '', url); } catch {}
          apply();
        });
        options.append(button);
      };
      makeButton('', nav.dataset.sizeAll);
      allowedSizes.filter(size => choices.includes(size) || selected.has(size)).forEach(size => makeButton(size,size));
      function apply() {
        const filtering = selected.size > 0;
        options.querySelectorAll('button').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.sizeValue ? selected.has(button.dataset.sizeValue) : !filtering));
        });
        if (filtering) {
          grid.replaceChildren(...cards);
          let matches = 0;
          cards.forEach(card => {
            const match = sizesOf(card).some(size => selected.has(size));
            card.classList.toggle('raaw-archive-size-hidden', !match);
            if (match) matches++;
          });
          siblings.forEach(el => el.classList.add('raaw-archive-size-hidden'));
          empty.classList.toggle('raaw-archive-size-hidden', matches > 0);
          if (count) count.textContent = matches + ' ' + nav.dataset.sizeCount;
          if (recommendations) recommendations.classList.add('raaw-archive-size-hidden');
        } else {
          grid.replaceChildren(...initialCards);
          initialCards.forEach(card => card.classList.remove('raaw-archive-size-hidden'));
          siblings.forEach(el => el.classList.remove('raaw-archive-size-hidden'));
          empty.classList.add('raaw-archive-size-hidden');
          if (count) count.innerHTML = originalCount;
          if (recommendations) recommendations.classList.remove('raaw-archive-size-hidden');
        }
        status.textContent = nav.dataset.sizeNote;
      }
      apply();
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = nav.dataset.sizeError;
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('.raaw-archive-filters a');
    if (!link) return;
    const url = new URL(link.href);
    if (!link.classList.contains('raaw-archive-clear')) [...selected].forEach(size => url.searchParams.append('raaw_size', size));
    link.href = url;
  }, true);
  window.addEventListener('popstate', () => { selected = new Set(new URL(location.href).searchParams.getAll('raaw_size')); activeGrid = null; mount(); });
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(mount, 100);
  }).observe(document.documentElement, {childList:true,subtree:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount);
  else mount();
})();
